(() => {
  const root = document.querySelector('[data-installments]');
  if (!root) return;

  const count = parseInt(root.dataset.count, 10) || 3;
  const amountEl = root.querySelector('[data-installment-amount]');
  const prices = {};

  root.dataset.prices.split(',').forEach((pair) => {
    const [id, price] = pair.split(':');
    prices[id] = parseInt(price, 10);
  });

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input.name !== 'id' || !input.closest('form[id^="product-form-"]')) return;

    const price = prices[input.value];
    if (price === undefined) return;

    const amount = Math.round(price / 100 / count);
    amountEl.textContent = amount;
    root.hidden = amount < 1;
  });
})();